/* global d3: true; */
import pym from 'pym.js';
import throttle from 'lodash.throttle';


const pymChild = new pym.Child();

const popGenderListItems = document.querySelectorAll('#pop-gender-list li');

const data = [
  {
    group: 'State Population',
    men: 49,
    women: 51,
    source: 'Source: U.S. Census 2022',
  },
  {
    group: 'District Attorneys',
    men: 88.1,
    women: 11.9,
    source: 'Source: Louisiana District Attorneys Association Roster 2022',
  },
  {
    group: 'Sheriffs',
    men: 98.4,
    women: 1.6,
    source: 'Source: Louisiana Sheriffs’ Association Directory 2022',
  },
  {
    group: 'Prisons',
    men: 94.6,
    women: 5.4,
    source: 'Source: Louisiana Department of Public Safety & Corrections, Oct 2022',
  },
  {
    group: 'Jails',
    men: 91.8,
    women: 8.2,
    source: 'Source: Bureau of Justice Statistics, Census of Jails, 2019',
  },
];

let svg;
let arc;
let pie;

// grabbing initial window width
let windowWidth = window.innerWidth;

let currentData = [51, 49];

function drawChart(chartData) {
  const containerWidth = document.querySelector('.pie-container').offsetWidth;
  const containerHeight = containerWidth * 0.6;

  const width = containerWidth;
  const height = containerHeight;
  const radius = Math.min(width, height) / 2;

  arc = d3.arc()
    .outerRadius(radius - 10)
    .innerRadius(0);

  pie = d3.pie()
    .startAngle(-5.40)
    .sort(null)
    .value(d => d);

  svg = d3.select('#pop-gender-pie').html('').append('svg')
    .attr('width', width)
    .attr('height', height)
    .append('g')
    .attr('transform', `translate(${width / 2}, ${height / 2})`);

  const path = svg.selectAll('path')
    .data(pie(chartData))
    .enter()
    .append('g')
    .append('path')
    .attr('d', arc)
    .attr('fill', (d, i) => (i === 1 ? 'url(#diagonal-stripe-1)' : '#4970ce'))
    .style('stroke', 'white')
    .style('stroke-width', '3');

  d3.select('#female__value').text(`${chartData[0]}%`);
  d3.select('#male__value').text(`${chartData[1]}%`);

  pymChild.sendHeight();
}

function updateChart(newData) {
  const path = svg.selectAll('path')
    .data(pie(newData))
    .transition()
    .duration(0)
    .attr('d', arc);

  d3.select('#women__value').text(`${newData[0]}%`);
  d3.select('#men__value').text(`${newData[1]}%`);
  pymChild.sendHeight();
}

drawChart(currentData);

popGenderListItems.forEach((li) => {
  li.addEventListener('click', (e) => {
    const currentActive = document.querySelector('#pop-gender-list li.active');
    currentActive.classList.remove('active');
    e.target.classList.add('active');

    const targetGroup = e.target.innerText;
    const selectedData = data.find(d => d.group === targetGroup);
    const newData = [selectedData.women, selectedData.men];
    updateChart(newData);
    currentData = newData;
    d3.select('#source_line').text(selectedData.source);
  });
});

// listen for window resizes, and if the width changes,
// redraw the graphic. Upon redraw, the graphic svg will be
// cleared, new width for the parent element will be pulled, and
// that new width will serve as the new base width of the graphic
// we also throttle this resize event listener so as to reduce the number
// of redraws per window resize
window.addEventListener('resize', throttle(() => {
  const newWindowWidth = window.innerWidth;

  if (newWindowWidth !== windowWidth) {
    drawChart(currentData);
    windowWidth = newWindowWidth;

    pymChild.sendHeight();
  }
}), 250);


pymChild.sendHeight();
